// Instance wsClient configurada per-app (v0.2.0 factory pattern)
import { createWSClient } from '@crm/websocket-client'

export const wsClient = createWSClient({
  url: import.meta.env.VITE_WS_URL ?? '',
})
